import { render } from "./RequestProfileReserveList.vue?vue&type=template&id=2d6fdbdc&ts=true"
import script from "./RequestProfileReserveList.vue?vue&type=script&lang=ts"
export * from "./RequestProfileReserveList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__